export default {
  brand: 'USFans Spreadsheet',
  nav_home: 'Home',
  nav_guide: 'Guide',
  nav_shopping_guide: 'Shopping Guide',
  nav_categories: 'Categories',
  nav_article: 'Articles',
  nav_faq: 'FAQ',
  nav_safety: 'Safety',

  hero_eyebrow: 'USFANS SPREADSHEET RESOURCE HUB',
  hero_h1: 'USFans Spreadsheet — Find Better Lists, Guides & Resources',
  hero_desc:
    'Explore organized USFans spreadsheet resources, shopping guides, seller information, QC tips, shipping details, reviews and practical comparisons — all in one place.',
  hero_cta_main: 'USFans Spreadsheet',
  hero_cta_buy: 'Buy It Now',
  hero_cta_guide: 'Read the Guide',
  hero_trust: 'Independent resource · Updated regularly · Multilingual · Safety-focused',

  categories_title: 'Browse Product Categories',
  categories_subtitle: 'Jump straight to the category you are looking for on the main website.',
  categories_dropdown_label: 'Choose a category',
  categories_all: 'All categories',

  about_eyebrow: 'WHAT IS USFANS SPREADSHEET?',
  about_title: 'Everything You Need About USFans Spreadsheet',
  about_desc:
    'Instead of searching through scattered information, explore a structured USFans Spreadsheet resource hub covering useful lists, shopping guides, seller research, QC, shipping, warehouse information, reviews, coupons and safety guides.',
  about_cta: 'Explore USFans Spreadsheet',

  resources_eyebrow: 'POPULAR RESOURCES',
  resources_title: 'Popular USFans Resources',
  resources_subtitle: 'Dive deeper with our original, helpful guides and articles.',
  article_card_title: 'USFans Spreadsheet: Complete Guide',
  article_card_desc:
    'Learn what a USFans spreadsheet is, how to use it, and how to shop smarter with organized lists and resources.',
  read_more: 'Read the article',
  read_guide: 'Read the guide',

  pillars_eyebrow: 'USFANS PILLAR GUIDES',
  pillars_title: 'In-Depth USFans Guides',
  pillars_subtitle:
    'Explore our original pillar articles covering reviews, shipping, coupons, warehouse, safety and more.',

  safety_title: 'Is USFans Legit and Safe?',
  safety_desc:
    'Before using any online shopping platform, verify the website address, protect your account information, research payment methods and stay cautious with suspicious offers. Our safety resources explain practical ways to reduce common online risks.',
  safety_cta: 'Visit the Safety Center',

  faq_title: 'Frequently Asked Questions',
  faq_subtitle: 'Quick answers to the most common questions about the USFans Spreadsheet.',
  faq_1_q: 'What is the USFans Spreadsheet?',
  faq_1_a:
    'The USFans Spreadsheet is an organized resource that gathers product links, categories and shopping details in one place, helping you browse and compare items more efficiently.',
  faq_2_q: 'Where can I find the USFans spreadsheet links?',
  faq_2_a:
    'You can explore the product categories directly on this page or continue to the main website to view the full selection of links and products.',
  faq_3_q: 'Is the USFans spreadsheet updated regularly?',
  faq_3_a:
    'Yes, it is refreshed regularly to reflect current categories and links. Always confirm the latest information on the main website before ordering.',

  final_title: 'Ready to Explore USFans Spreadsheet Resources?',
  final_desc:
    'Start with the complete USFans Spreadsheet guide, explore practical resources and compare important information before continuing to the main website.',
  final_cta_main: 'Explore USFans Spreadsheet',
  final_cta_buy: 'Visit Main Website',

  footer_tagline:
    'An independent multilingual resource hub for the USFans Spreadsheet — original guides, lists and safety information.',
  footer_explore: 'Explore',
  footer_resources: 'Resources',
  footer_languages: 'Languages',
  footer_disclaimer:
    'USFansSheet.casa is an independent informational resource and is not officially affiliated with or endorsed by USFans unless explicitly stated.',

  back_home: 'Back to Home',
  related_article: 'Related resources',
  visit_main_site: 'Visit the main website',
  article_not_found: 'Article not found',

  category_shoes: 'Shoes',
  category_hoodies: 'Hoodies/Sweaters',
  category_tshirts: 'T-Shirts',
  category_jackets: 'Jackets',
  category_pants: 'Pants/Shorts',
  category_headwear: 'Headwear',
  category_sets: 'Sets',
  category_underwear: 'Underwear/Underpants',
  category_jersey: 'Jersey',
  category_accessories: 'Accessories',
  category_bags: 'Bags',
  category_belts: 'Belts',
  category_perfumes: 'Perfumes',
  category_other: 'Other Stuff',
};